<script setup lang="ts">
defineProps<{
  modelValue?: string
  disabled?: boolean
  min?: string
  max?: string
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <input
    type="date"
    :value="modelValue"
    :disabled="disabled"
    :min="min"
    :max="max"
    class="w-full bg-surface-container-high text-on-surface font-mono text-sm px-3 py-2 border border-border rounded focus:outline-none focus:ring-1 focus:ring-primary/30 disabled:opacity-40 disabled:cursor-not-allowed transition-shadow dark:[color-scheme:dark]"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
  />
</template>
